// Sanitizing on SSR is performant costly, so we better ensure that the texts in backoffice are getting saved sanitized
export const sanitizeHTML = (string: string) => string;
